<template>
  <v-form
    ref="form"
    v-model="valid"
    @submit.prevent="onSubmit"
  >
    <v-card
      height="100%"
      flat
    >
      <v-card-title>
        <slot name="form-title">
          <span class="font-weight-semibold text-base text--primary">{{
            $t('Accord Signature')
          }}</span>
          <v-spacer />
          <v-spacer></v-spacer>
          <v-btn
            icon
            small
            @click="$emit('update:is-form-active',false)"
          >
            <v-icon size="22">
              {{ icons.mdiClose }}
            </v-icon>
          </v-btn>
        </slot>
      </v-card-title>

      <v-card-text
        class="overflow-y-auto"
        style="max-height: 500px;"
      >
        <v-row class="pt-5">
          <v-col
            cols="12"
          >
            <v-select
              v-model="status_id"
              :label="$t('Statut')"
              :rules="[validators.required]"
              :error-messages="errorMessages.status_id"
              :items="statuses"
              item-text="name"
              item-value="id"
              outlined
              dense
              hide-details="auto"
            >
            </v-select>
          </v-col>
          <v-col
            cols="12"
          >
            <v-textarea
              v-model="comment"
              :label="$t('Commentaire')"
              outlined
              dense
              hide-details="auto"
            >
            </v-textarea>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <slot name="form-actions">
          <slot name="form-cancel">
            <v-btn
              :loading="loading"
              color="secondary"
              outlined
              type="reset"
              @click="dialog = false"
            >
              {{ $t('Annuler') }}
            </v-btn>
          </slot>
            <v-spacer />
            <v-btn
              :loading="loading"
              color="primary"
              class="me-3"
              type="submit"
          >
            {{ $t('Enregistrer') }}
          </v-btn>
        </slot>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import {
  mdiClose, mdiPencilOutline, mdiPencilOffOutline, mdiCalendar,
} from '@mdi/js'
import { computed, ref, watch } from '@vue/composition-api'
import { required, emailValidator } from '@core/utils/validation'
import axios from '@axios'
import { format, parse } from 'date-fns'
import store from '@/store'
import controller from './Controller'
import authorsController from '@/views/apps/author/author-list/useAuthorsList'
import AvatarName from '@/components/AvatarName'
import AuthorForm from '@/views/apps/author/author-list/AuthorForm'
import useAuthorsList from '@/views/apps/author/author-list/useAuthorsList'

export default {
  components: {
    AuthorForm,
    AvatarName,
  },
  model: {
    prop: 'object',
    event: 'update:is-form-active',
  },
  props: {
    object: {
      type: Object,
      default: () => {
      },
    },
    isFormActive: {
      type: Boolean,
      required: true,
    },
    withPassword: {
      type: Boolean,
      default: true,
    },
    roleOptions: {
      type: Array,
      default: () => [],
    },
    planOptions: {
      type: Array,
      default: () => [],
    },
  },
  setup(props, { emit }) {
    const {
      form,
      isSnackbarBottomVisible,
      snackBarMessage,
      accordDialog,
    } = controller()
    const {} = authorsController()
    const errorMessages = ref({})
    const valid = ref(false)
    const modalReceipt = ref(false)
    const isFormAuthorActive = ref(false)
    const loading = ref(false)
    const isLoadingOrders = ref(false)
    const authors = ref([])
    const fees = ref([])
    const statuses = ref([])
    const isLoadingAuthors = ref(false)
    const search = ref(null)
    const status_id = ref(null)
    const comment = ref(null)
    const validate = () => {
      form.value.validate()
    }

    const item = computed({
      get: () => props.object,
      set: value => emit('update:object', value),
    })
    const dialog = computed({
      get: () => props.isFormActive,
      set: value => emit('is-form-active', value),
    })

    // const item = ref(JSON.parse(JSON.stringify(blankItem)))
    const resetItem = () => {
      // item.value = {}

      // emit('update:object', item.value)
    }
    const formatDate = (date, f) => format(date, f)
    const newAuthor = () => {
      item.value.author = {
        full_name: search.value,
        email: null,
        phone: null,
        addresses: [],
      }
      isFormAuthorActive.value = true
    }
    axios
      .get('/statuses', { params: { per_page: 500, type: 'order' } })
      .then(response => {
        statuses.value = response.data.data
      }).catch(error => console.log(error))
    const searchAuthors = term => {
      store.dispatch('app/searchAuthors', {
        term,
        rowsPerPage: 100,
      })
        .then(response => {
          isLoadingAuthors.value = false
          authors.value = response.data.data
        })
    }
    axios.get('/fees')
      .then(response => {
        fees.value = response.data.data
      })
    const updateAuthors = author => {
      authors.value.push(author)
      item.value.author_id = author.id
    }

    const onSubmit = () => {
      if (valid.value) {
        loading.value = true
        store.dispatch('app-order/actionOnItem', {
          path: `/orders/action/accept_signature/${item.value.id}`,
          item: {
            id: item.value.id,
            status_id: status_id.value,
            comment: comment.value,
          },
        })
          .then(response => {
            console.log('pass world')
            loading.value = false
            accordDialog.value = false
            if (response.data.error || response.data.errors || (response.data.status && response.data.status === 'false')) {
              if (response.data.errors) {
                // this.toast(this.$t('These credentials do not match our records'), this.$vuetify.theme.currentTheme.error)
                errorMessages.value = { ...response.data.errors }
              } else {
                isSnackbarBottomVisible.value = true
                snackBarMessage.value = response.data.message

                // this.toast(response.data.message, this.$vuetify.theme.currentTheme.error)
              }

              return true
            }
            resetItem()

            /* axios.post('/publications', {
              order_id: item.value.id,
              author_id: item.value.author_id,
              original_price: item.value.public_price,
              price: item.value.price,
            }) */

            // emit('update:is-form-active', false)
            dialog.value = false
            emit('refetch-data')
          })
          .catch(error => {
            loading.value = false
            console.log('error', error)
            if (error.data.errors) {
              // this.toast(this.$t('These credentials do not match our records'), this.$vuetify.theme.currentTheme.error)
              errorMessages.value = { ...error.data.errors }
            }
          })
      } else {
        validate()
      }
    }

    searchAuthors('')

    // onMounted(searchParticular)
    watch(search, val => {
      if (!val || val.trim().length < 3 || isLoadingAuthors.value) return ''
      isLoadingAuthors.value = true
      searchAuthors(val)

      return ''
    })
    const calculatePrice = () => {
      const fee = fees.value.find(i => i.page_min <= item.value.sum_pages && i.page_max >= item.value.sum_pages)

      if (fee && (item.value.sum_pages)) {
        item.value.public_price = parseFloat(fee.frais)/* + (parseFloat(item.value.sum_pages - fee.subtraction) * fee.percentage).toFixed(2) */
        console.log(item.value.public_price)
      } else {
        item.value.public_price = store.state.app.settings.default_pages_price || 27
      }
    }
    const calculatePages = () => {
      // item.value.sum_pages = null
      if (!item.value.custom_pages && item.value.sum_words >= 0) {
        const words = store.state.app.settings.number_words_per_page || 260
        item.value.sum_pages = Math.ceil(item.value.sum_words / words)
      } else {
        console.log('test')
        item.value.sum_pages = null
      }
    }
    const nbPages = computed({
      get: () => item.value.sum_pages,

      /* set: value => emit('update:object', value), */
    })
    const nbWords = computed({
      get: () => item.value.sum_words,
    })
    watch(nbPages, val => {
      calculatePrice()

      return ''
    })
    watch(nbWords, val => {
      calculatePages()

      return ''
    })


    store
      .dispatch('app/fetchSources', { per_page: 500 })


    return {
      status_id,
      comment,
      resetItem,
      form,
      isFormAuthorActive,
      isLoadingOrders,
      isSnackbarBottomVisible,
      snackBarMessage,
      errorMessages,
      search,
      authors,
      statuses,
      isLoadingAuthors,
      onSubmit,
      updateAuthors,
      modalReceipt,
      formatDate,
      newAuthor,
      accordDialog,
      item,
      valid,
      dialog,
      loading,
      validate,

      // validation
      validators: {
        required,
        emailValidator,
      },
      icons: {
        mdiClose,
        mdiPencilOffOutline,
        mdiPencilOutline,
        mdiCalendar,
      },
    }
  },
}
</script>
